import { IoMdArrowDropright } from "react-icons/io";
import fauna_preservacao from "../../../mockups/paineis/Frame 76_transparente.png"

export default function FaunaPreservacao({ getImagem }) {
  return (
    <div className="flex justify-center px-16 py-10">
      {/* <div className="border border-grayLight rounded-3xl overflow-hidden flex flex-col">
        <header className="bg-blue text-white py-6 text-center">
          <h1 className="text-4xl font-bold">Fauna silvestre</h1>
        </header>

        <div className="p-8 flex flex-col gap-14 h-full justify-center">
          <div className="flex items-center justify-center gap-6">
            <img
              src={getImagem(8)}
              className="h-[130px] rounded-3xl"
              alt="Imagem de um animal silvestre"
            />

            <div>
              <h1 className="text-5xl font-bold text-deepBlue">+49 mil</h1>
              <p className="text-2xl font-semibold text-deepBlue">
                animais recebidos
              </p>
              <p className="text-[20px] text-greenDark">(desde 2021)</p>
            </div>
          </div>

          <div className="flex items-center justify-center gap-6">
            <img
              src={getImagem(9)}
              className="h-[130px] rounded-3xl"
              alt="Imagem de um animal silvestre"
            />

            <div>
              <h1 className="text-5xl font-bold text-deepBlue">+18 mil</h1>
              <p className="text-2xl font-semibold text-deepBlue">
                animais devolvidos
              </p>
              <p className="text-[20px] text-greenDark">(desde 2021)</p>
            </div>
          </div>
        </div>
      </div>

      <div className="border border-grayLight rounded-3xl overflow-hidden flex flex-col">
        <header className="bg-blue text-white py-6 text-center">
          <h1 className="text-4xl font-bold">Preservação ambiental</h1>
        </header>

        <div className="p-8 flex flex-col justify-between h-full">
          <div className="flex items-center justify-center gap-6">
            <img
              src={getImagem(10)}
              className="h-[130px] rounded-3xl"
              alt="Imagem de um ambiente natural"
            />

            <div>
              <h1 className="text-5xl font-bold text-deepBlue">50%</h1>
              <p className="text-2xl font-semibold text-deepBlue">
                do território com cobertura vegetal
              </p>
            </div>
          </div>

          <div className="flex flex-col items-center gap-2">
            <p className="text-3xl font-semibold text-deepBlue">
              DUP | Declaração de Utilidade Pública
            </p>

            <div className="flex items-center gap-8">
              <div className="text-end">
                <h1 className="text-5xl font-bold text-deepBlue">11%</h1>
                <p className="text-3xl font-semibold text-deepBlue">
                  do território
                </p>
              </div>

              <IoMdArrowDropright fontSize={120} className="text-greenDark" />

              <div>
                <h1 className="text-5xl font-bold text-deepBlue">26%</h1>
                <p className="text-3xl font-semibold text-deepBlue">
                  em processo
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <img src={fauna_preservacao} alt="" />
    </div>
  );
}
